/**
 * TODO: Discuss the design for full screen mode
 */
import React from 'react';
import {
  Button,
  ButtonProps,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogActionsProps,
  DialogContent as MuiDialogContent,
  DialogContentProps,
  DialogProps as MuiDialogProps,
  DialogTitle as MuiDialogTitle,
  DialogTitleProps,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Close, SlideshowOutlined } from '@mui/icons-material';

interface DialogAction {
  label: string | React.ReactNode;
  props?: ButtonProps;
}

export interface DialogProps extends MuiDialogProps {
  title?: string;
  subtitle?: string | React.ReactNode;
  children?: React.ReactNode;
  actions?: Array<DialogAction>;
  muiDialogTitleProps?: Partial<DialogTitleProps>;
  muiDialogContentProps?: DialogContentProps;
  muiDialogActionsProps?: DialogActionsProps;
  onHelp?: Function;
}

export const Dialog = ({
  title,
  subtitle,
  children,
  actions = [],
  muiDialogTitleProps,
  muiDialogContentProps,
  muiDialogActionsProps,
  onClose,
  onHelp,
  ...rest
}: DialogProps) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <MuiDialog
      fullScreen={rest.fullScreen || fullScreen}
      onClose={onClose}
      {...rest}
    >
      <MuiDialogTitle
        {...(muiDialogTitleProps as any)}
        component="div"
        sx={{
          pl: { sm: 6.25 },
          pr: { xs: 4, sm: 6.25 },
          py: { xs: 3, sm: 6.25 },
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          ...muiDialogTitleProps?.sx,
        }}
      >
        <Typography variant="h3" sx={{ fontSize: { xs: 32, sm: 48 } }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>
          {subtitle}
        </Typography>
        {onHelp && (
          <IconButton
            sx={{
              position: 'absolute',
              right: { xs: 36, sm: 50 },
              top: { xs: 6, sm: 22 },
              color: 'primary.contrastText',
            }}
            onClick={() => onHelp && onHelp()}
          >
            <SlideshowOutlined />
          </IconButton>
        )}

        <IconButton
          sx={{
            position: 'absolute',
            right: { xs: 6, sm: 20 },
            top: { xs: 6, sm: 22 },
            color: 'primary.contrastText',
          }}
          onClick={event => onClose && onClose(event, 'escapeKeyDown')}
        >
          <Close />
        </IconButton>
      </MuiDialogTitle>

      <MuiDialogContent {...muiDialogContentProps}>{children}</MuiDialogContent>

      <MuiDialogActions
        {...muiDialogActionsProps}
        sx={{
          justifyContent: 'center',
          ...muiDialogActionsProps?.sx,
        }}
      >
        {actions.map(item => (
          <Button {...item.props}>{item.label}</Button>
        ))}
      </MuiDialogActions>
    </MuiDialog>
  );
};
